"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const am4core = require("@amcharts/amcharts4/core");
const core_1 = require("@angular/core");
const Subject_1 = require("rxjs/Subject");
// license of timeline
am4core.addLicense("TL227989214");
// license of charts
am4core.addLicense("CH227989214");
let AreaTimelineControlComponent = class AreaTimelineControlComponent {
    constructor() {
        this.destroy$ = new Subject_1.Subject();
        this.data = [
            {
                "category": "Case 27678725",
                "1$createdDate": "2019-01-18 16:30:00",
                "1$updatedDate": "2019-01-18 18:30:00",
                "2$createdDate": "2019-02-10 14:00:00",
                "2$updatedDate": "2019-02-10 18:00:00",
                "task": "Application 11 created"
            },
            {
                "category": "Case 256787",
                "1$createdDate": "2019-01-18 16:30:00",
                "1$updatedDate": "2019-01-18 18:30:00",
                "2$createdDate": "2019-02-10 14:00:00",
                "2$updatedDate": "2019-02-10 18:00:00",
                "3$createdDate": "2019-01-15 15:30:00",
                "3$updatedDate": "2019-01-15 18:00:00",
                "task": "Application 11 created"
            },
            {
                "category": "Case 75875725725",
                "1$createdDate": "2019-01-18 16:30:00",
                "1$updatedDate": "2019-01-18 18:30:00",
                "2$createdDate": "2019-02-10 14:00:00",
                "2$updatedDate": "2019-02-10 18:00:00",
                "3$createdDate": "2019-01-15 15:30:00",
                "3$updatedDate": "2019-01-15 18:00:00",
                "task": "Application 11 created"
            }
        ];
        this.series = [
            { id: 1, name: 'Application 1' },
            { id: 2, name: 'Application 2' },
            { id: 3, name: 'Application 3' },
        ];
    }
    ngAfterViewInit() {
        this.initChart();
    }
    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
    initChart() {
        //         am4core.useTheme(am4themes_animated);
        //
        //         let chart = am4core.create(this.el.nativeElement, am4charts.XYChart);
        //
        //         chart.paddingRight = 40;
        //
        //         let data = [];
        //         let value = {};
        //         (function(){
        //             let dateOrigin = new Date('01 01 2005');
        //             for (let i = 0; i < 140160; i++) {
        //                 dateOrigin.setTime(dateOrigin.getTime() + 60*60*1000);
        //                 let date = dateOrigin;
        //                 for(let j = 1; j < 31; j++){
        //                     value[j] = getValue();
        //                 }
        //                 data.push(Object.assign({}, { date: new Date(date.getTime())}, value));
        //
        //             }
        //             chart.data = data;
        //         })()
        //
        //
        // // Create axes
        //         let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
        //         dateAxis.renderer.minGridDistance = 60;
        //         dateAxis.groupData = true;
        //
        //         let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        //
        //         for(let j = 1; j < 4; j++){
        //             let series = chart.series.push(new am4charts.LineSeries());
        //             series.dataFields.valueY = `${j}`;
        //             series.dataFields.dateX = "date";
        //             series.tooltipText = "{value}";
        //             series.tooltip.background.fill = am4core.color("#551122");
        //             series.tooltip.getStrokeFromObject = true;
        //             series.tooltip.background.strokeWidth = 3;
        //             series.tooltip.getFillFromObject = false;
        //             series.fillOpacity = 0.6;
        //             series.strokeWidth = 2;
        //             series.stacked = true;
        //             series.tooltip.pointerOrientation = "vertical";
        //         }
        //
        //
        //
        //         chart.cursor = new am4charts.XYCursor();
        //
        //         chart.scrollbarX = new am4core.Scrollbar();
        //
        //         function getValue(){
        //             let value = 50;
        //             value -= Math.round((Math.random() < 0.5 ? 1 : -1) * Math.random() * 10);
        //             if (value < 0) {
        //                 value = Math.round(Math.random() * 10);
        //             }
        //             return value;
        //         }
    }
};
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], AreaTimelineControlComponent.prototype, "id", void 0);
__decorate([
    core_1.ViewChild('chartContainer'),
    __metadata("design:type", core_1.ElementRef)
], AreaTimelineControlComponent.prototype, "el", void 0);
AreaTimelineControlComponent = __decorate([
    core_1.Component({
        
        selector: 'sis-area-timeline-control',
        styles: [require('./area-timeline-control.component.css')],
        template: require('./area-timeline-control.component.html')
    }),
    __metadata("design:paramtypes", [])
], AreaTimelineControlComponent);
exports.AreaTimelineControlComponent = AreaTimelineControlComponent;
//# sourceMappingURL=area-timeline-control.component.js.map